import { ArrowBackIosNew } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

import { MenuModulesPanel } from 'components/header/menu-modules/mobile/MenuModulesNavigationStack';

type MenuModulesSubmenuTitle = {
    currentPanel: MenuModulesPanel;
    onBack(): void;
};

export function MenuModulesSubmenuTitle({ currentPanel, onBack }: MenuModulesSubmenuTitle) {
    return (
        <Box onClick={onBack} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <IconButton
                size="small"
                sx={{
                    width: 24,
                    height: 24,
                    color: 'inherit',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                }}
            >
                <ArrowBackIosNew sx={{ fontSize: 13 }} />
            </IconButton>

            <Typography variant="inherit" noWrap>
                {currentPanel.title}
            </Typography>
        </Box>
    );
}
